import {object, string, mixed} from 'yup'

export const danceMediaSchema = object({
    fileType: string().required('required'),
    file: mixed().required('required'),
})
